import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import ConfigurationSourceDataConfigurationList from "@/components/lists/status/ConfigurationSourceDataConfigurationList";
import TrialContext from "@/contexts/data/TrialContext";
import { ConfigurationSourceDatasTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useConfigurationSourceDatas from "@/hooks/data/useConfigurationSourceDatas";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";

const ConfigurationSourceDatas: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: sourceDatas, loading: sourceDatasLoading, validating: sourceDatasValidating } = useConfigurationSourceDatas(trial?.id ? {trialId: trial.id, isGlobal: false} : undefined);

    const loading = sourceDatasLoading;
    const validating = sourceDatasValidating;

    return (
        <>
            <SetLinks 
                createTrialLink={ConfigurationSourceDatasTrialCreateLink} 
                institutionLinkEnabled={false} 
                participantLinkEnabled={false} 
            />
            <IsLoading name="configuration-source-datas-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Configuration &mdash; Source Data
                </Typography>
                <ConfigurationSourceDataConfigurationList 
                    data={sourceDatas}
                />
            </Show>
        </>
    )
};

export default ConfigurationSourceDatas;